import { AppRoute } from '@/modules/settings/types'
import {
  BasicSettingsPage,
  BusinessTripPage,
  BusinessTripRatesPage,
  TimesheetBasicPage,
  TimesheetAdditionalPage,
  ViolationPage,
  ExchangeRatePage,
  CountryPage,
  PrintoutPage,
  AlertRemindersPage,
  GpsPage,
  ScannerPage,
  IntegrationPage,
  EmailSettingsPage,
  FileImportPage,
  PayrollModulePage,
  IpAccessPage,
} from './pages';

import {
  BelgiumMinimumWageSettingsPage,
  AustriaMinimumWageSettingsPage,
  DenmarkMinimumWageSettingsPage,
  FinlandMinimumWageSettingsPage,
  FranceMinimumWageSettingsPage,
  GenericMinimumWageSettingsPage,
  SwedenMinimumWageSettingsPage,
  NorwayMinimumWageSettingsPage,
  LuxemburgMinimumWageSettingsPage,
  PolandMinimumWageSettingsPage,
  GermanyMinimumWageSettingsPage,
  HollandMinimumWageSettingsPage,
  ItalyMinimumWageSettingsPage,
  GeneralMinimumWageSettingsPage,
  CzechRepublicMinimumWageSettingsPage,
} from './pages/minimumWage/pages'

import { SETTINGS_ROUTES } from './routes-typed'

export const settingsRoutesMap: Record<string, string> = {
  basic: SETTINGS_ROUTES.basic.path,
  businessTrip: SETTINGS_ROUTES.businessTrip.path,
  businessTripRates: SETTINGS_ROUTES.businessTripRates.path,
  timesheetBasic: SETTINGS_ROUTES.timesheetBasic.path,
  timesheetAdditional: SETTINGS_ROUTES.timesheetAdditional.path,
  minimumWage: SETTINGS_ROUTES.minimumWage.path,
  minimumWageCountry: SETTINGS_ROUTES.minimumWageCountry.path,
  violation: SETTINGS_ROUTES.violation.path,
  exchangeRate: SETTINGS_ROUTES.exchangeRate.path,
  country: SETTINGS_ROUTES.country.path,
  printout: SETTINGS_ROUTES.printout.path,
  alertReminders: SETTINGS_ROUTES.alertReminders.path,
  gps: SETTINGS_ROUTES.gps.path,
  scanner: SETTINGS_ROUTES.scanner.path,
  integration: SETTINGS_ROUTES.integration.path,
  emailConfiguration: SETTINGS_ROUTES.emailConfiguration.path,
  payrollModule: SETTINGS_ROUTES.payrollModule.path,
  ipAccess: SETTINGS_ROUTES.ipAccess.path,
}

export const settingsRoutes: AppRoute[] = [
  {
    path: settingsRoutesMap.basic,
    exact: true,
    // name: 'Podstawowe',
    component: BasicSettingsPage,
  },
  {
    path: settingsRoutesMap.businessTrip,
    // name: 'Delegacje',
    component: BusinessTripPage,
  },
  {
    path: settingsRoutesMap.businessTripRates,
    // name: 'Stawki delegacji',
    component: BusinessTripRatesPage,
  },
  {
    path: settingsRoutesMap.timesheetBasic,
    // name: 'Ewidencja - dane podstawowe',
    component: TimesheetBasicPage,
  },
  {
    path: settingsRoutesMap.timesheetAdditional,
    // name: 'Ewidencja - dane dodatkowe',
    component: TimesheetAdditionalPage,
  },
  {
    path: settingsRoutesMap.minimumWage,
    exact: true,
    component: GeneralMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'austria'), // '/et/company/:companyId/configuration/minimum-wage/austria',
    exact: true,
    component: AustriaMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'belgium'), // '/et/company/:companyId/configuration/minimum-wage/belgium',
    exact: true,
    component: BelgiumMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'danemark'), // '/et/company/:companyId/configuration/minimum-wage/denmark',
    exact: true,
    component: DenmarkMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'finland'), // '/et/company/:companyId/configuration/minimum-wage/finland',
    exact: true,
    component: FinlandMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'france'), // '/et/company/:companyId/configuration/minimum-wage/france',
    exact: true,
    component: FranceMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'germany'), // '/et/company/:companyId/configuration/minimum-wage/germany',
    exact: true,
    component: GermanyMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'holland'), // '/et/company/:companyId/configuration/minimum-wage/holland',
    exact: true,
    component: HollandMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'italy'), // '/et/company/:companyId/configuration/minimum-wage/italy',
    exact: true,
    component: ItalyMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'luxemburg'), // '/et/company/:companyId/configuration/minimum-wage/luxemburg',
    exact: true,
    component: LuxemburgMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'norway'), // '/et/company/:companyId/configuration/minimum-wage/norway',
    exact: true,
    component: NorwayMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'poland'), // '/et/company/:companyId/configuration/minimum-wage/poland',
    exact: true,
    component: PolandMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'sweden'), // '/et/company/:companyId/configuration/minimum-wage/sweden',
    exact: true,
    component: SwedenMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry.replace(':country', 'czechRepublic'), // '/et/company/:companyId/configuration/minimum-wage/czechRepublic',
    exact: true,
    component: CzechRepublicMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.minimumWageCountry, // '/et/company/:companyId/configuration/minimum-wage/:country',
    exact: true,
    component: GenericMinimumWageSettingsPage,
  }, {
    path: settingsRoutesMap.violation,
    // name: 'Naruszenia',
    component: ViolationPage,
  },
  {
    path: settingsRoutesMap.exchangeRate,
    // name: 'Kursy walut',
    component: ExchangeRatePage,
  },
  {
    path: settingsRoutesMap.country,
    // name: 'Państwa',
    component: CountryPage,
  },
  {
    path: settingsRoutesMap.printout,
    // name: 'Wydruki',
    component: PrintoutPage,
  },
  {
    path: settingsRoutesMap.alertReminders,
    // name: 'Przypomnienia',
    component: AlertRemindersPage,
  },
  {
    path: settingsRoutesMap.gps,
    // name: 'Dane GPS',
    component: GpsPage,
  },
  {
    path: settingsRoutesMap.integration,
    // name: 'Integracja z systemami',
    component: IntegrationPage,
  },
  // {
  //   path: settingsRoutesMap.adminPanel,
  //   // name: 'Panel administracyjny',
  //   component: AdminPanelPage,
  // },
  {
    path: settingsRoutesMap.scanner,
    // name: 'Skaner',
    component: ScannerPage,
  },
  {
    path: settingsRoutesMap.emailConfiguration,
    // name: 'Konfiguracja e-mail',
    component: EmailSettingsPage,
  },
  // {
  //   path: settingsRoutesMap.fileImport,
  //   // name: 'Import plików',
  //   component: FileImportPage,
  // },
  {
    path: settingsRoutesMap.payrollModule,
    // name: 'Moduł płacowy',
    component: PayrollModulePage,
  },
  {
    path: settingsRoutesMap.ipAccess,
    // name: 'Dostęp z IP',
    component: IpAccessPage,
  },
];
